/** @jsxImportSource @emotion/react */
import { Dropdown, DropDownProps } from "antd";
import React from "react";
import { DropdownMenuWrapper } from "../module/common/DropdownMenuWrapper";
import { css } from "@emotion/react";
import { colors } from "./colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

const dropdownInnerWrapper = css`
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
`;

export const ellipsisStyle = css`
  display: flex;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  color: ${colors.textSecondary};
  &:hover {
    color: ${colors.textPrimary};
  }
`;

export const EllipsisDropdown = ({ ...rest }: DropDownProps) => {
  return (
    <Dropdown
      placement="bottomRight"
      dropdownRender={(menu) => (
        <DropdownMenuWrapper>
          <div css={dropdownInnerWrapper}>
            {React.cloneElement(menu as React.ReactElement, {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                boxShadow: "none",
                padding: "0px",
                backgroundColor: "transparent",
              },
            })}
          </div>
        </DropdownMenuWrapper>
      )}
      {...rest}
    >
      <div css={ellipsisStyle}>
        <FontAwesomeIcon icon={solid("ellipsis")} />
      </div>
    </Dropdown>
  );
};
